// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BackwardFilledSvg from "@fishx/icons-svg/es/asn/BackwardFilled";
import FishxIcon from '../components/FishxIcon';

var BackwardFilled = function BackwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BackwardFilledSvg
  }));
};

BackwardFilled.displayName = 'BackwardFilled';
export default React.forwardRef(BackwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BackwardFilled.js
// module id = 2044
// module chunks = 0